import React from "react";
import { Button } from "@/components/ui/button";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid md:grid-cols-2 bg-background">
      {/* Left: brand image */}
      <div className="hidden md:flex relative items-center justify-center bg-[#DFECFA] overflow-hidden">
        <img
          src="/brand/medishiv-hero.jpg"
          alt="Medishiv — दवा, दुआ और सेवा"
          data-testid="login-hero-image"
          className="w-full h-full object-contain p-10"
        />
        <div className="absolute bottom-8 left-8 right-8 text-center text-sm text-slate-600">
          Preventive care, delivered to your door — trusted by Brahma Kumaris families.
        </div>
      </div>

      {/* Right: login card */}
      <div className="flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          {/* mobile-only inline logo */}
          <div className="md:hidden mb-6 flex justify-center">
            <img
              src="/brand/medishiv-hero.jpg"
              alt="Medishiv"
              className="max-w-[260px] w-full h-auto"
            />
          </div>
          <div className="label-caps text-primary mb-3">Staff sign-in</div>
          <h2 className="font-heading text-3xl md:text-4xl tracking-tight text-foreground mb-3">
            Welcome back to the Medishiv console.
          </h2>
          <p className="text-muted-foreground mb-8">
            Sign in with your authorised Medishiv Google account to access live
            enrollments, orders, prescriptions and member data.
          </p>

          <Button
            data-testid="google-login-btn"
            onClick={handleLogin}
            className="w-full h-12 bg-primary hover:bg-primary/90 text-primary-foreground rounded-xl text-base"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" className="mr-3">
              <path fill="#FFF" d="M21.35 11.1h-9.17v2.98h5.29c-.23 1.36-1.62 3.98-5.29 3.98-3.18 0-5.78-2.63-5.78-5.87s2.6-5.87 5.78-5.87c1.81 0 3.02.77 3.71 1.43l2.53-2.44C16.79 3.7 14.7 2.8 12.18 2.8 6.94 2.8 2.72 7.02 2.72 12.19s4.22 9.39 9.46 9.39c5.46 0 9.08-3.83 9.08-9.23 0-.62-.07-1.09-.17-1.25z"/>
            </svg>
            Continue with Google
          </Button>

          <div className="mt-8 text-xs text-muted-foreground leading-relaxed">
            Access is restricted to the Medishiv admin allowlist. Please contact
            your administrator if you need access.
          </div>
        </div>
      </div>
    </div>
  );
}
